// extracted by mini-css-extract-plugin
export default {"disclaimer":"disclaimer___FJi59"};